import Types from "./Types";

const INIT_STATE = {
  employees: [],
  employee: {},
  count: 0,
  load: null,
};

export default function employeesReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.EMPLOYEES_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_EMPLOYEES_SUCCESS: {
      return {
        ...state,
        employees: payload?.data?.employees,
        count: payload?.extra?.total_count,
      };
    }
    case Types.GET_EMPLOYEE_DETAILS_SUCCESS: {
      return {
        ...state,
        employee: payload?.data?.employee,
      };
    }
    case Types.UPDATE_EMPLOYEE_SUCCESS: {
      return {
        ...state,
        employees: state?.employees?.map((emp) => {
          if (emp.id === payload?.data?.employee?.id) {
            return payload?.data?.employee;
          }
          return emp;
        }),
        employee: payload?.data?.employee,
      };
    }
    case Types.DELETE_EMPLOYEE_SUCCESS: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}
